<script setup lang="ts">
import { computed } from "vue";

import AuthToken from "~/components/AuthToken.vue";
import UpgradeConfirmationDialog from "~/components/dumb/UpgradeConfirmationDialog.vue";
import { N8nIcon, OpenExternalLinkIcon } from "~/icons";
import { Subscription } from "~/shared/enums";
import { useTenantStore } from "~/stores";

const tenantStore = useTenantStore();

const upgradeRequired = computed(() => !tenantStore.isSubscriptionGte(Subscription.PREMIUM));
</script>

<template>
  <div class="flex flex-col gap-y-16">
    <div class="flex flex-col justify-center space-y-3">
      <h2 class="select-none text-xl text-md">n8n integration</h2>
      <p class="select-none text-sm/relaxed text-lt">
        Integrate n8n with Dart to create agents, automate your workflows, and connect Dart with more than a thousand
        other apps.
      </p>
    </div>

    <UpgradeConfirmationDialog
      feature-action="use the n8n integration"
      :subscription="Subscription.PREMIUM"
      :disabled="!upgradeRequired">
      <a
        :href="!upgradeRequired ? `https://www.npmjs.com/package/n8n-nodes-dart` : undefined"
        target="_blank"
        rel="noopener noreferrer"
        class="flex cursor-pointer select-none items-center justify-center gap-2 self-center rounded border px-3 py-2 text-center text-base shadow-sm text-md border-md focus-ring-std hover:bg-lt">
        <N8nIcon class="icon-md" />
        Link Dart and n8n
        <OpenExternalLinkIcon class="icon-md" />
      </a>
    </UpgradeConfirmationDialog>
    <AuthToken />
  </div>
</template>
